import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { connectedGroupListApi } from "../../../../services/groups";
import { toastMessage } from "../../../../utils/toastMessage";
import OverviewListShimmer from "../../../../shimmer/overview/OverviewListshimmer";
import InfiniteScroll from "react-infinite-scroll-component";
import { updateFavoriteListHandler } from "../groupSubModules/LikeUnlikeHeart";
import { GoDotFill } from "react-icons/go";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import NotFoundPlaceHolder from "../../../../components/not-found/NotFoundPlaceHolder";

const ConnectedGroup = ({ groupId }) => {
  const [connectedGroupList, setConnectedGroupList] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [showShimmer, setShowShimmer] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  //------------navigate-details-page-------------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  //--------------listing-API------------------------
  const getConnectedGroupHandler = async (page = 1, isRefresh = false) => {
    try {
      setShowShimmer(true);
      const { data } = await connectedGroupListApi({
        _id: groupId,
        pagination: true,
        page,
        limit: 9,
      });
      const { success, message, data: response } = data;
      if (success) {
        if (isRefresh) {
          setConnectedGroupList(response || []);
        } else {
          setConnectedGroupList((prev) => [...prev, ...(response || [])]);
        }
        setHasMore(response.length === 9);
      } else {
        toastMessage(message, "error", "getConnectedGroupHandler");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getConnectedGroupHandler(1, true);
  }, [groupId]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      getConnectedGroupHandler(nextPage);
      return nextPage;
    });
  };

  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          {connectedGroupList?.length > 0 || showShimmer ? (
            <InfiniteScroll
              dataLength={connectedGroupList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<GroupCardSkeleton count={5} />}
              // endMessage={
              //   <p style={{ textAlign: "center", margin: "25px" }}>
              //     <b>No more data to display</b>
              //   </p>
              // }
            >
              <div className="health_hub_cards">
                {connectedGroupList && connectedGroupList.length > 0
                  ? connectedGroupList?.map((data, ind) => (
                      <div key={data?._id + ind} className="health_hub_img">
                        <div
                          onClick={() => navigateDetailsPage(data?._id)}
                          className="image_containerss pointer-cursor"
                        >
                          <img src={data?.coverImage} />
                          <div className="health_hub_img_text">
                            <h6>{data?.name}</h6>
                            <p>
                              {data?.newFeeds?.count > 0 ? (
                                <>
                                  <GoDotFill className="live_dot" />
                                  {`${data?.newFeeds?.count} New Post${
                                    data?.newFeeds?.count > 1 ? "s" : ""
                                  }`}
                                </>
                              ) : null}
                            </p>
                          </div>
                        </div>

                        <div className="health_hub_containt">
                          <span className="tag dark">{data?.categoryName}</span>

                          <figure className="health_hub_icons">
                            {data?.type === "SUBSCRIPTION" && (
                              <img
                                src={subscription_icon}
                                className="lockimg"
                              />
                            )}
                            {data?.type === "PRIVATE" && (
                              <img src={lock_icon} className="lockimg" />
                            )}
                            <img
                              src={
                                data?.favoriteGroup?.status === "ACTIVE"
                                  ? fill_heart
                                  : heart_icon
                              }
                              className="heartimg"
                              onClick={() =>
                                updateFavoriteListHandler(
                                  data?._id,
                                  setConnectedGroupList,
                                  data?.favoriteGroup?.status === "ACTIVE"
                                    ? "INACTIVE"
                                    : "ACTIVE"
                                )
                              }
                            />
                          </figure>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </InfiniteScroll>
          ) : (
            <NotFoundPlaceHolder title="No Groups available" />
          )}
        </div>
      </div>
    </>
  );
};

export default ConnectedGroup;
